import React from 'react';
import { Badge, Card, Link, TextStyle } from '@superops/ui-design-system';

import { PATCH_COLOR_MAP } from '@nile/rmm/src/constants';
import AssetTypeCell from '@nile/rmm/src/modules/asset-management/components/sub-pages/asset-type-cell';
import { AccessControl } from '@nile/components';

function AlertCardDetails({
  alert,
  tabContext
}: {
  tabContext: any;
  alert: any;
}) {
  return (
    <>
      <div className="mb5">
        <div>
          <div>
            <Badge status={PATCH_COLOR_MAP[alert.severity]}>
              {alert.severity}
            </Badge>
            <span className="ml-5">
              <TextStyle weight="Medium">{alert.message}</TextStyle>
            </span>
          </div>
        </div>
      </div>
      <Card noShadow padding="sizeSmall" variant="secondaryCard">
        <Link
          fontWeight="bold"
          onClick={() => {
            tabContext?.current?.openTabCb({
              module: 'ASSET_DETAILS',
              data: {
                id: alert?.asset?.assetId,
                subject: alert?.asset?.name,
                classId: alert?.asset?.assetClass?.classId
              }
            });
          }}
        >
          <div className="flex actr">
            <AssetTypeCell
              cell={{
                row: {
                  original: alert?.asset
                }
              }}
            />
            <div className="ml-5">{alert?.asset?.name}</div>
          </div>
        </Link>
        <div className="mt-10">
          <TextStyle variation="subdued">
            <div className="flex actr g5">
              <AccessControl
                productToCheck="MSP"
                render={<div>{`${alert?.asset?.client.name}, `}</div>}
              />
              <div>{`${alert?.asset?.site.name}`}</div>
            </div>
          </TextStyle>
        </div>
      </Card>
    </>
  );
}

export default AlertCardDetails;
